// src/utils/services/AdvancedMD/telehealth20.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const TELEHEALTH20_URL = `${API_BASE_URL}/api/advancedmd/telehealth20`;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

/**
 * Obtiene las notas clínicas "TELEHEALTH_2.0" de un paciente.
 */
export async function getTelehealth20Notes(patientId) {
  try {
    const url = `${TELEHEALTH20_URL}/${encodeURIComponent(patientId)}`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    console.error("Error getTelehealth20Notes:", err);
    throw err;
  }
}
